import { aClient, aUser, useAtomValue } from '~/atoms'
import type { Listing } from '~/models'

type ListingLinkProps = {
  clientID: string
  clientName: string
  listing: string
  user?: string
}

function buildListingLink({
  clientID,
  clientName,
  listing,
  user,
}: ListingLinkProps) {
  const params = new URLSearchParams({
    i: clientID,
    c: clientName,
    m: 'direct',
  })

  if (user) {
    params.set('u', user)
  }

  return `https://resimplifi.link/v1/${listing}?${params.toString()}`
}

function isValidURL(url?: string | null): boolean {
  if (!url) return false

  try {
    const { hostname: host, protocol } = new URL(url)

    return (
      (protocol === 'http:' || protocol === 'https:') &&
      !(
        host.split('.').includes('portal') ||
        host.endsWith('.internal') ||
        /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(
          host
        )
      )
    )
  } catch {
    return false
  }
}

export function useListingLink({
  slug,
  source_url,
}: Pick<Listing, 'slug' | 'source_url'>) {
  const client = useAtomValue(aClient)
  const user = useAtomValue(aUser)

  if (!isValidURL(source_url)) {
    return undefined
  }

  if (!slug || !client) {
    return source_url
  }

  return buildListingLink({
    clientID: client.id,
    clientName: client.name,
    listing: slug,
    user: user?.id,
  })
}
